import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
    Popover
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { onFieldsChange, getAgentsAndAreas, getStatisticTotal, getStatisticList } from './action';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';
import errImg from '../../../circleRed.png';

class OrderList extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
        this.getOtion = this.getOtion.bind(this);
    }

    componentDidMount() {
      if(this.props.match.params.id){
        let arr = this.props.match.params.id.split(',');
        let taskid = arr[0];
        this.props.onFieldsChange({ taskid: taskid });
        if(arr[1] && arr[2]){
          let sTime = arr[1]+' 00:00';
          let eTime = arr[2]+' 23:59';
          this.props.onFieldsChange({ beginTimeView: moment(sTime,'YYYY-MM-DD HH:mm'),
                                      endTimeView: moment(eTime,'YYYY-MM-DD HH:mm'),
                                      beginTime: sTime,
                                      endTime: eTime
                                    });
        }
      }
        this.props.getAgentsAndAreas(); //查询地区和合作商列表
        this.props.getStatisticTotal(); //查询任务统计的表格数据
        this.props.getStatisticList(); //查询任务统计的echarts数据
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(_obj);
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'beginTimeView') {
                if (fields[key].value && fields[key].value > 0) {
                    let startTime = fields[key].value._d;
                    startTime.setHours(0);
                    startTime.setMinutes(0);
                    startTime.setSeconds(0);
                    startTime.setMilliseconds(0);
                    console.log(fields[key]);
                    _obj['beginTimeView'] = fields[key].value;
                    _obj['beginTime'] =
                        new Date(fields[key].value).getTime() == 0
                            ? ''
                            : moment(startTime.getTime()).format('YYYY-MM-DD HH:mm');
                    // _obj['beginTime'] ='2017-12-25 13:00';
                } else {
                    _obj['beginTimeView'] = null;
                    _obj['beginTime'] = null;
                }
            } else if (key === 'endTimeView') {
                if (fields[key].value && fields[key].value > 0) {
                    let endTime = fields[key].value._d;
                    endTime.setHours(23);
                    endTime.setMinutes(59);
                    endTime.setSeconds(59);
                    endTime.setMilliseconds(0);
                    _obj['endTimeView'] = fields[key].value;
                    _obj['endTime'] =
                        new Date(fields[key].value).getTime() == 0
                            ? ''
                            : moment(endTime.getTime()).format('YYYY-MM-DD HH:mm');
                    // _obj['endTime'] = '2017-12-25 14:00';
                } else {
                    _obj['endTimeView'] = null;
                    _obj['endTime'] = null;
                }
            } else {
                _obj[key] = fields[key].value;
            }
        });
        this.props.onFieldsChange(Object.assign(_obj));
        //this.fieldsOnChangeImpl(fields);
    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => { });
    }

    getOtion(data, name) {
        const option = {
            title: {
                text: name,
            },
            tooltip: {
                trigger: 'axis',
            },
            legend: {
                data: data.legend,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: 40,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data.xAxis,
            },
            yAxis: {
                type: 'value',
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                    'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: data.series,
        };
        return option;
    }

    cleaningEchartsData(taskStatisticData, key) {
        if (!taskStatisticData) {
            return {};
        }
        let source = taskStatisticData.name;
        let datas = taskStatisticData.map;
        let xAxisData = taskStatisticData.xAxis_data;
        let legendData = [],seriesData = [];
        if('all' == source){
          Object.keys(datas).forEach((_key, index) => {
              let name = "统计基准线";
              let nameOne = "标准基准线";
              let detailData = datas[_key];
              let series = [];
              let lineName;
              if(key == 'completeNum'){
                lineName = '执行量';
              } else if(key == 'distinctIpNum'){
                lineName = 'ip量';
              } else if(key == 'errorNum'){
                lineName = '失败量';
              } else if(key == 'syserrCount'){
                lineName = '系统错误量';
              }
              legendData.push(lineName);
              let standers = [];
              let standards = [];
              if( key == 'completeNum'){
                legendData.push(name);
                legendData.push(nameOne);
                detailData.forEach((item, index) => {
                    series.push(item[key]);
                    standers.push(item['standerNum']);
                    standards.push(item['standardNum']);
                });
              } else {
                detailData.forEach((item, index) => {
                    series.push(item[key]);
                });
              }
              let line = {
                  name: lineName,
                  smooth: true,
                  type: 'line',
                  itemStyle: {
                      normal: {
                          color: "#00aeef",
                          lineStyle: {
                              color: "#00aeef"
                          }
                      }
                  },
                  data: series,
              };
              seriesData.push(line);
              if( key == 'completeNum'){
                let lineOne = {
                    name: name,
                    smooth: true,
                    type: 'line',
                  itemStyle: {
                        normal: {
                            color: "#ec008c",
                            lineStyle: {
                                color: "#ec008c"
                            }
                        }
                    },
                    data: standers,
                };
                let lineTwo = {
                    name: nameOne,
                    smooth: true,
                    type: 'line',
                    itemStyle: {
                        normal: {
                            color: "#fff200",
                            lineStyle: {
                                color: "#fff200"
                            }
                        }
                    },
                    data: standards,
                };
                seriesData.push(lineOne);
                seriesData.push(lineTwo);
              }
          })
        } else {
          Object.keys(datas).forEach((_key, index) => {
              let detailData = datas[_key];
              let series = [];
              legendData.push(_key);
              detailData.forEach((item, index) => {
                  series.push(item[key]);
              });
              let line = {
                  name: _key,
                  smooth: true,
                  type: 'line',
                  data: series,
              };
              seriesData.push(line);
          })
        }
        return {
            xAxis: xAxisData,
            series: seriesData,
            legend: legendData,
        };
    }

    render() {
      let behaviourColumns = [
          {
              title: '索引位',
              dataIndex: 'index'
          },
          {
              title: '成功率',
              dataIndex: 'successRate',
              render: (text, record) =>  Number(record.behaviourSuccessCount/(record.behaviourSuccessCount+record.behaviourErrorCount)*100).toFixed(2) + '%',
          }
        ]
        let columns = [
            {
                title: '任务id',
                dataIndex: 'taskId',
                sorter: (a, b) => a.taskId - b.taskId
            },
            {
                title: '订单名称',
                dataIndex: 'taskDescription',
                sorter: (a, b) => a.taskDescription.length - b.taskDescription.length
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                sorter: (a, b) => a.taskName.length - b.taskName.length
            },
            {
                title: '广告id',
                dataIndex: 'adId',
                sorter: (a, b) => a.adId - b.adId
            },
            {
                title: 'ps',
                dataIndex: 'ps',
                sorter: (a, b) => a.ps - b.ps
            },
            {
                title: '时间',
                dataIndex: 'dateTime',
                sorter: (a, b) => Date.parse(new Date(a.dateTime)) - Date.parse(new Date(b.dateTime)),
            },
            {
                title: 'IP总数',
                dataIndex: 'sum',
                sorter: (a, b) => a.sum - b.sum,
            },
            {
                title: '去重IP数',
                dataIndex: 'distinctIpNum',
                sorter: (a, b) => a.distinctIpNum - b.distinctIpNum,
            },
            {
                title: 'IP重复率',
                dataIndex: 'ipRepetitionRate',
                sorter: (a, b) => a.ipRepetitionRate - b.ipRepetitionRate,
                render: text => Number(text).toFixed(2) + '%',
            },
            {
                title: '代理质量',
                dataIndex: 'proxyQuality',
                sorter: (a, b) => a.proxyQuality - b.proxyQuality,
                render: text => Number(text).toFixed(2) + '%',
            },
            {
                title: '行为总量',
                dataIndex: 'behaviorNum',
                sorter: (a, b) => a.behaviorNum - b.behaviorNum,
            },
            {
                title: '溢出量',
                dataIndex: 'overflow',
                sorter: (a, b) => a.overflow - b.overflow,
            },
            {
                title: '当日已完成量',
                dataIndex: 'completeNum',
                sorter: (a, b) => a.completeNum - b.completeNum,
            },
            /*{
                title: 'PV数',
                dataIndex: 'pv',
                sorter: (a, b) => a.pv - b.pv,
            },*/
            {
                title: 'UV数',
                dataIndex: 'uv',
                sorter: (a, b) => a.uv - b.uv,
            },
            {
                title: 'Url错误',
                dataIndex: 'urlErrorCount',
                sorter: (a, b) => a.urlErrorCount - b.urlErrorCount,
            },
            {
                title: '无返回错误',
                dataIndex: 'noResultErrorCount',
                sorter: (a, b) => a.noResultErrorCount - b.noResultErrorCount,
            },
            {
                title: '库存零错误',
                dataIndex: 'statusZeroErrorCount',
                sorter: (a, b) => a.statusZeroErrorCount - b.statusZeroErrorCount,
            },
            {
                title: '脚本成功率',
                dataIndex: 'scriptSuccessRate',
                sorter: (a, b) => a.scriptSuccessRate - b.scriptSuccessRate,
                render: (text, record) =>  record.scriptSuccessRate != null ? Number(record.scriptSuccessRate*100).toFixed(2) + '%':null,
            },
            {
                title: '行为数据成功率',
                dataIndex: 'behaviorSuccessRate',
                sorter: (a, b) => a.behaviorSuccessRate - b.behaviorSuccessRate,
                render: (text, record) => (
                    <div>
                        <Popover content={<Table columns={behaviourColumns} dataSource={record.indexBehaviourEntities} pagination={false} bordered />} title="行为数据索引位置成功率">
                            {record.behaviorSuccessRate != null ? Number(record.behaviorSuccessRate*100).toFixed(2) + '%':null}
                        </Popover>
                    </div>
                ),
                // render: (text, record) =>  record.behaviorSuccessRate != null ? Number(record.behaviorSuccessRate*100).toFixed(2) + '%':null,
            },
            {
                title: '失败率',
                dataIndex: 'errorRate',
                sorter: (a, b) => a.errorRate - b.errorRate,
                //sortOrder: sortedInfo.columnKey === 'errorRate' && sortedInfo.order,
                //render: text => Number(text).toFixed(2) + '%',
                render: (text, record) => record.errorRate > 30 ? <span style={{color:"red"}}><img src={errImg} style={{paddingRight:'10px' }}/>{Number(record.errorRate).toFixed(2) + '%'}</span> : Number(record.errorRate).toFixed(2) + '%',
            },
            {
                title: '监测代码请求次数(平均/期望)',
                dataIndex: 'irCountAndExcept',
                sorter: (a, b) => a.irCountAndExcept - b.irCountAndExcept,
            },
            {
                title: '任务返回页面大小(平均)',
                dataIndex: 'dataSize',
                sorter: (a, b) => a.dataSize - b.dataSize,
            },
            // {
            //     title: '分布',
            //     key: 'action',
            //     render: record => (
            //         <div>
            //             <a>地区</a>&nbsp;&nbsp;<a>运营商</a>
            //         </div>
            //     ),
            // },
        ];
        const { statisticTotal, loading, statisticList } = this.props;

        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    
                    <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                   
                    
                    <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(statisticList, 'completeNum'), '成功量')}
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(statisticList, 'distinctIpNum'), 'IP量')}
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                    </Row>
                    <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(statisticList, 'errorNum'), '失败量')}
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <ReactEcharts
                                option={this.getOtion(this.cleaningEchartsData(statisticList, 'syserrCount'), '系统错误量')}
                                style={{ height: '350px', width: '90%' }}
                                className="react_for_echarts"
                                notMerge={true}
                                lazyUpdate={true}
                            />
                        </Col>
                    </Row>
                    {/* <Row className="wrapperBox" style={{ marginTop: '10px', marginTop: '10px' }}> */}
                    <Table columns={columns} dataSource={statisticTotal} pagination={false} bordered />
                    {/* </Row> */}

                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.taskStatistic.loading.loading,
    search: state.taskStatistic.search,
    areas: state.taskStatistic.areas,
    agents: state.taskStatistic.agents,
    statisticTotal: state.taskStatistic.statisticTotal,
    statisticList: state.taskStatistic.statisticList,
});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getAgentsAndAreas: () => dispatch(getAgentsAndAreas()),
    getStatisticTotal: () => dispatch(getStatisticTotal()),
    getStatisticList: () => dispatch(getStatisticList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getStatisticTotal();
        this.props.getStatisticList();
    }

    render() {
        const { areas, agents } = this.props;
        const { getFieldDecorator } = this.props.form;
        const queryTimes = [
            {name: '9点前', value: 1},
            {name: '9点后', value: 2},
            {name: '全天', value: 3},
            {name: '9点后及全天', value: 4},
        ];
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>任务统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6} >
                            <FormItem label="任务ID" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('taskid')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={6} >
                            <FormItem label="广告ID" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('adid')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="PS" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('ps')(<Input style={{ width: 200 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="合作商" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('agent')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {agents.map((item, index) => {
                                            return (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem label="开始时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('beginTimeView')(
                                    <DatePicker style={{ width: 200 }} showTime format="YYYY-MM-DD HH:mm" />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="结束时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('endTimeView')(
                                    <DatePicker style={{ width: 200 }} showTime format="YYYY-MM-DD HH:mm" />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="地区" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('area')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {areas.map((item, index) => {
                                            return (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="时间段" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('queryTimeSection')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {queryTimes.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.value}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="项目类型" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('test')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        <Option key={1} value="1">
                                            非测试
                                        </Option>
                                        <Option key={2} value="0">
                                            测试
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="失败率" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('showErrorData')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        <Option key={1} value="1">
                                            高
                                        </Option>
                                        <Option key={2} value="0">
                                            所有
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        {/* <Col span={6}>
                            <FormItem label="运营商" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('net')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        <Option key={1} value="电信">
                                            电信
                                        </Option>
                                        <Option key={2} value="联通">
                                            联通
                                        </Option>
                                        <Option key={3} value="移动">
                                            移动
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                                重置
                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            taskid: {
                value: props.search.taskid,
            },
            adid: {
                value: props.search.adid,
            },
            ps: {
                value: props.search.ps,
            },
            agent: {
                value: props.search.agent,
            },
            beginTimeView: {
                value: props.search.beginTimeView,
            },
            endTimeView: {
                value: props.search.endTimeView,
            },
            area: {
                value: props.search.area,
            },
            net: {
                value: props.search.net,
            },
            queryTineSection: {
                value: props.search.queryTineSection,
            },
            test: {
                value: props.search.test,
            },
            showErrorData: {
                value: props.search.showErrorData,
            },
        };
    },
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/task-statistics/index.js